'use strict';

document.addEventListener('DOMContentLoaded', function ()
{
    // Get all anchor tags to convert to email addresses
    var elements = document.querySelectorAll('[id^="sem-link-convert"]');

    // While there are elements to convert
    for (var i = 0; i < elements.length; i++) {

        // replace the HREF with the correct anchor tag
    	elements[i].setAttribute('href', elements[i].getAttribute('href')
    		.replace('-', 'o@')
    		.replaceAll('-', '')
            .replace('contact', 'sacredearth')
    		.replace('us/', 'medicine.org')
    		.replace('to', 'mailto:hell')
            .replace('legal', 'mailto:leg')
            .replace('+', 'al@')
            .replaceAll('+', '')
    	);
    
    }
});